<template>
  <!-- Header -->
  <div class="relative md:pt-24 pb-32 pt-12" style="background: #8E2DE2;
    background: -webkit-linear-gradient(to left, #4A00E0, #8E2DE2);
    background: linear-gradient(to left, #4A00E0, #8E2DE2);">
    <div class="px-4 md:px-10 mx-auto w-full">
      <div>
        <!-- Card stats -->
        <div class="flex flex-wrap">
        
        </div>
      </div>
    </div>
  </div>
</template>

